// extracted by mini-css-extract-plugin
module.exports = {"textarea":"cT8R4","count":"hn5HI","border":"_9tEB2","textarea_title_180":"v8abp","textarea_title_250":"TTztp","border_focused":"NIvA7"};